/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
// 2. Third-party library imports
import {
    createSlice,
    PayloadAction
} from '@reduxjs/toolkit';

// Utility functions
import { ResponseModalObject } from '../../utils/commonInterfaces';

// Redux actions (types, store)
import { BankFileCustomization, BanksState } from './types';
import type { RootState } from '../storeTypes';

// Type-safe initialState!
export const initialState: BanksState = {
    loading: false,
    bankFileCustomization: undefined,
    saveLoading: false
};

const bankSlice = createSlice({
    name: 'bank',
    initialState,
    reducers: {
        saveBankFileRequestAction: {
            reducer: (
                state,
                action: PayloadAction<{
                    payload: any;
                    callback?: (response: ResponseModalObject) => void;
                }>
            ) => {
                state.saveLoading = true;
            },
            prepare: (
                payload: any,
                callback?: (response: ResponseModalObject) => void
            ) => ({
                payload: {
                    payload,
                    callback
                }
            })
        },
        saveBankFileResponseAction: (state) => {
            state.saveLoading = false;
        },
        getBankFileAction: (state) => {
            state.loading = true;
        },
        getBankFileSuccessAction: (
            state,
            action: PayloadAction<BankFileCustomization | undefined>
        ) => {
            state.loading = false;
            state.bankFileCustomization = action.payload;
        },
    }
});

const { actions, reducer } = bankSlice;

// Actions
export const {
    saveBankFileRequestAction,
    saveBankFileResponseAction,
    getBankFileAction,
    getBankFileSuccessAction
} = actions;

// Selectors
export const getBanksState = (state: RootState) => state.banks;

// Reducer
export default reducer;